const QuestionTags = ({ handleUserQuestionTagSelect, userQuestionTag, questionTags }) => {
  return (
    <div className="flex flex-wrap gap-4 md:gap-2 mt-3 md:mt-0 justify-start md:justify-end">
      {questionTags?.map((tag) => (
        <div
          className={`flex text-sm md:text-base items-center justify-start cursor-pointer py-2 md:py-1 pl-2 pr-3 h-fit w-full md:w-fit border rounded-xl md:rounded-full ${
            userQuestionTag === tag._id
              ? 'bg-[var(--q3-blue-light)] border-[var(--q3-blue-normal)]'
              : 'border-[var(--q3-stroke-normal)] bg-[var(--q3-surface-default)] text-[var(--q3-neutral-default)] q3-interaction-scale-down'
          }`}
          onClick={() => handleUserQuestionTagSelect(tag._id)}
        >
          <img src={tag?.icon} alt={tag?.title} className={`mr-2 h-4 w-4 md:h-5 md:w-5`} />
          {tag?.title}
        </div>
      ))}
    </div>
  );
};

export default QuestionTags;
